import { object, mixed } from 'yup';

export const schema = object().shape({
  file: mixed().required('File is required'),
});
